import { getTableData, sendMessageApi, getDetail, getReceivedTableData } from '@/axios/api/message'
import { getUserData } from '@/axios/api/userGroup'
import { Message } from 'element-ui'


const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_RECEIVED_TABLEDATA = 'UPDATE_RECEIVED_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_RECEIVED_TOTAL = 'UPDATE_RECEIVED_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_RECEIVED_SEARCH = 'UPDATE_RECEIVED_SEARCH'
const UPDATE_PARAMS = 'UPDATE_PARAMS'
const UPDATE_RECEIVED_PARAMS = 'UPDATE_RECEIVED_PARAMS'
const UPDATE_DET_LOADING = 'UPDATE_DET_LOADING'
const UPDATE_DETAIL = 'UPDATE_DETAIL'
const UPDATE_USER = 'UPDATE_USER'
const UPDATE_GROUP = 'UPDATE_GROUP'
const UPDATE_SENDER_LIST = 'UPDATE_SENDER_LIST'
const UPDATE_RECIPIENT_LIST = 'UPDATE_RECIPIENT_LIST'

const state = {
	tableData: [],
	receivedTableData: [],
	tblLoading: false,
	detailLoading: false,
	pager: {
		current: 1,
		size: 10,
		total: 0
	},
	receivedPager: {
		current: 1,
		size: 10,
		total: 0
	},
	params: {
		senderId: '',
		recipientId: '',
		title: ''
	},
	receivedParams: {
		senderId: '',
		title: '',
		type: '',
		sentData: []
	},
	detail: {
		id: "",
		recipientId: [],
		userGroupId: [],
		messegeTitle: "",
		content: "",
		createDate: ""
	},
	userList: [], // 新增消息时选择发送者下拉框
	groupList: [], // 新增消息时选择用户组下拉框
	senderList: [], // 搜索时发送人下拉
	recipientList: [] // 搜索时接收人下拉
}



const getters = {
	tableData: state => state.tableData,
	receivedTableData: state => state.receivedTableData,
	tblLoading: state => state.tblLoading,
	detailLoading: state => state.detailLoading,
	pager: state => state.pager,
	receivedPager: state => state.receivedPager,
	params: state => state.params,
	receivedParams: state => state.receivedParams,
	detail: state => state.detail,
	userList: state => state.userList.map(v => {
		return {
			label: v.name,
			value: v.id
		}
	}),
	groupList: state => state.groupList.map(v => {
		return {
			label: v.groupName,
			value: v.id
		}
	}),
	senderList: state => state.senderList.map(v => {
		return {
			label: v.account,
			value: v.id
		}
	}),
	recipientList: state => state.recipientList.map(v => {
		return {
			label: v.name,
			value: v.id
		}
	}),

}

const mutations = {
	[UPDATE_TOTAL](state, total) {
		state.pager = { ...state.pager, total }
	},
	[UPDATE_RECEIVED_TOTAL](state, total) {
		state.receivedPager = { ...state.receivedPager, total }
	},
	[UPDATE_TBL_LOADING](state, tblLoading) {
		state.tblLoading = tblLoading
	},
	[UPDATE_TABLEDATA](state, tableData) {
		state.tableData = tableData
	},
	[UPDATE_RECEIVED_TABLEDATA] (state, receivedTableData) {
		state.receivedTableData = receivedTableData.map(item => {
      const arr = item.content.match(/@#@(.+)@#@/)
      const orange = item.content.match(/<orange>(.*?)<\/orange>/g) || []
      const clickHere = arr ? arr[1] : ''
      let content = item.content.replace(
        /@#@(.+)@#@/g,
        '<span class="click-here" style="color:#21bdbb; text-decoration:underline;cursor:pointer">' + clickHere + '</span>'
      )
      let text = item.content.replace(/@#@(.+)@#@/g, clickHere)
      orange.forEach(v => {
        content = content.replace(v, '<span style="color:#f63">' + v + '</span>')
        text = text.replace(/<orange>|<\/orange>/, '')
      })
			return {
				...item,
				content: content,
				text: text,
				// param: item.param || {}
				param: item.param ? JSON.parse(item.param) : {}
			}
    })
	},
	[UPDATE_SEARCH](state, { pager, params }) {
		state.pager = { ...state.pager, ...pager }
		if (params) state.params = params
	},
	[UPDATE_RECEIVED_SEARCH](state, { pager, params }) {
		state.receivedPager = { ...state.receivedPager, ...pager }
		if (params) state.receivedParams = params
	},
	[UPDATE_PARAMS](state, params) {
		state.params = { ...state.params, params }
	},
	[UPDATE_RECEIVED_PARAMS](state, receivedParams) {
		state.receivedParams = receivedParams
	},
	[UPDATE_DET_LOADING](state, detailLoading) {
		state.detailLoading = detailLoading
	},
	[UPDATE_DETAIL](state, detail) {
		state.detail = detail
	},
	[UPDATE_USER](state, userList) {
		state.userList = userList
	},
	[UPDATE_GROUP](state, groupList) {
		state.groupList = groupList
	},
	[UPDATE_SENDER_LIST](state, senderList) {
		state.senderList = senderList
	},
	[UPDATE_RECIPIENT_LIST](state, recipientList) {
		state.recipientList = recipientList
	},

}

const actions = {
	// 初始化dialog
	initDetail({ commit }) {
		let detail = {
			id: "",
			recipientId: [],
			userGroupId: [],
			messegeTitle: "",
			content: "",
			createDate: ""
		}
		commit(UPDATE_DETAIL, detail)
	},
	// 获取列表数据
	async getTableDataApi({ commit }, params) {
		commit(UPDATE_TBL_LOADING, true)
		try {
			let { data: res } = await getTableData(params)
			commit(UPDATE_TABLEDATA, res.records)
			commit(UPDATE_TOTAL, res.total)
		} catch (e) { }
		commit(UPDATE_TBL_LOADING, false)
	},
	// 获取列表数据
	async getReceivedTableDataApi({ commit }, params) {
		commit(UPDATE_TBL_LOADING, true)
		try {
			let { data: res } = await getReceivedTableData(params)
			commit(UPDATE_RECEIVED_TABLEDATA, res.records)
			commit(UPDATE_RECEIVED_TOTAL, res.total)
		} catch (e) { }
		commit(UPDATE_TBL_LOADING, false)
	},
	// 设置page
	setPagerApi({ commit }, pager) {
		commit(UPDATE_SEARCH, { pager })
	},
	// 设置page
	setReceivedPagerApi({ commit }, pager) {
		commit(UPDATE_RECEIVED_SEARCH, { pager })
	},
	// 获取详情
	async getDetailApi({ commit }, params) {
		commit(UPDATE_DET_LOADING, true)
		try {
			const { data: res } = await getDetail(params)
			// 将详情user和group字段转成数字数组，用于反填
			if (res.recipientId) {
				res.recipientId = res.recipientId.split(',').map(Number)
			}
			if (res.userGroupId) {
				res.userGroupId = res.userGroupId.split(',').map(Number)
			}
			commit(UPDATE_DETAIL, res)
		} catch (e) { }
		commit(UPDATE_DET_LOADING, false)
	},
	changeLoadingApi({ commit }, flag) {
		commit(UPDATE_DET_LOADING, flag)
	},
	// 新增时搜索用户
	async getUserDataApi({ commit }, { keyword, type }) {
		try {
			const { data: res } = await getUserData({ keyword })
			if (type == 'user') {
				commit(UPDATE_USER, res)
			} else if (type == 'recipient') {
				commit(UPDATE_RECIPIENT_LIST, res)
			} else {
				commit(UPDATE_SENDER_LIST, res)
			}

		} catch (e) { }
	},
	// 新增消息
	async sendMessage({ commit }, params) {
		commit(UPDATE_DET_LOADING, true)
		try {
			await sendMessageApi(params)
			commit(UPDATE_DET_LOADING, false)
			Message.success('success')
			return true
		} catch (e) {
			commit(UPDATE_DET_LOADING, false)
			return false
		}
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js